import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ACTION_EXPORT_CAMPAIGN_REPORT } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_EXPORT_CAMPAIGN_REPORT, EXPORT_CAMPAIGN_REPORT_PENDING } from '@/app/module/reports/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export type ExportCampaignReportPayload = {
  campaignId: number
  fields?: string[]
  labels: boolean
  timezone: string
}

export const useExportCampaignReport = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [exportCampaignReport, res] = esApi.endpoints.exportCampaignReport.useLazyQuery()

  const exportReport = useCallback(
    async ({ campaignId, fields = [], labels, timezone }: ExportCampaignReportPayload) => {
      dispatch({
        type: ACTION_EXPORT_CAMPAIGN_REPORT,
        value: {
          engId: campaignId,
          orgId,
        },
      })

      try {
        const result = await exportCampaignReport({
          orgId: String(orgId),
          campaignId: String(campaignId),
          columns: fields.length > 0 ? fields : undefined,
          labels: labels ? 'true' : 'false',
          tz: timezone,
        }).unwrap()

        dispatch(
          createNotification({
            'export-campaign-report-pending': {
              type: 'success',
              message: EXPORT_CAMPAIGN_REPORT_PENDING,
            },
          }),
        )
        return result
      } catch (error) {
        dispatch(
          createNotification({
            'export-campaign-report-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_EXPORT_CAMPAIGN_REPORT),
            },
          }),
        )
        return undefined
      }
    },
    [dispatch, exportCampaignReport, orgId],
  )

  return [exportReport, res] as const
}
